import { useState, useRef, useEffect } from "react";


import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Experiencecommandata from '../Components/Experiencecommandata';
import ExperienceTripsDtlbanner from '../Components/ExperienceTripsDtlbanner';
import ExperienceTripsDtlowerview from '../Components/ExperienceTripsDtlowerview';
import ExperienceDtlcount from '../Components/ExperienceDtlcount';
import Experiencebooknow from '../Components/Experiencebooknow';
import Experiencebooking from '../Components/Experiencebooking';
import { API_BASE } from "../api/apiConfig";

const ExperienceTripsDtl = () => {


  const ReadMoreText = ({ text, className }) => {
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setShowToggle(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, []);

  return (
    <div>
      <p
        ref={textRef}
        className={`${className} ${expanded ? "" : "line-clamp-2"}`}
      >
        {text}
      </p>

      {showToggle && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-1 text-xs font-medium text-primary hover:underline"
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};


// Modal
  const [open, setOpen] = useState(false);

  
const [openDay, setOpenDay] = useState(1);

  const days = [
    {
      day: 1,
      title: "Arrival in Leh",
      image: "assets/images/leh-arrival.jpg",
      tags: ["Airport pickup", "Acclimatization"],
      description:
        "Arrive at Leh Airport (11,500 ft). Rest and acclimatize. Evening orientation and welcome dinner at a traditional Ladakhi home.",
    },
    {
      day: 2,
      title: "Leh Exploration",
      image: "assets/images/leh-palace.jpg",
      tags: ["Leh Palace", "Shanti Stupa"],
      description: "Explore Leh Palace, Shanti Stupa and local markets.",
    },
    {
      day: 3,
      title: "Leh to Nubra Valley",
      image: "assets/images/nubra-valley-dunes.jpg",
      tags: ["Khardung La", "Nubra Valley"],
      description: "Drive via Khardung La Pass to Nubra Valley.",
    },
    {
      day: 4,
      title: "Nubra Valley to Turtuk",
      image: "assets/images/turtuk-village.jpg",
      tags: ["Turtuk Village", "Balti Culture"],
      description:
        "Visit the beautiful Turtuk village and explore Balti culture.",
    },
    {
      day: 5,
      title: "Turtuk to Pangong Lake",
      image: "assets/images/pangong-lake-camping.jpg",
      tags: ["Scenic Drive", "Pangong Lake"],
      description: "Scenic drive to the stunning Pangong Lake.",
    },
    {
      day: 6,
      title: "Pangong Lake",
      image: "assets/images/pangong-sunrise.jpg",
      tags: ["Sunrise", "Spangmik"],
      description: "Sunrise at Pangong Lake and leisure time.",
    },
    {
      day: 7,
      title: "Pangong to Leh",
      image: "assets/images/hemis-monastery.jpg",
      tags: ["Chang La", "Hemis Monastery"],
      description:
        "Return to Leh via Chang La Pass, visit Hemis Monastery.",
    },
    {
      day: 8,
      title: "Departure",
      image: "assets/images/leh-departure.jpg",
      tags: ["Airport Transfer"],
      description: "Airport transfer and departure.",
    },
  ];
  return (
    <>

    <style>{`
      .common-section {
        padding:0;
      }
    `}</style>
      <Header />


<main className="flex-1">
  <main className="min-h-screen bg-white pb-20 md:pb-0">
    
    <ExperienceTripsDtlbanner />

    <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
      
      <ExperienceDtlcount />


      <div className="py-5 md:py-10 lg:py-16 lg:flex lg:gap-16 min-w-0">
        <div className="lg:flex-1 space-y-6 md:space-y-12 min-w-0">
          
         
          <ExperienceTripsDtlowerview />

          <Experiencecommandata />
          
          
          <section>
            <h2 className="text-base md:text-2xl font-bold text-slate-900 mb-3 md:mb-6">
              Frequently Asked Questions
            </h2>
            <div className="space-y-2.5 md:space-y-4">
              <div className="bg-slate-50 rounded-xl p-4 md:p-5">
                <h3 className="font-semibold text-slate-900 mb-1.5 md:mb-2 text-sm md:text-base">
                  What is the fitness level required?
                </h3>
                <p className="text-slate-600 text-xs md:text-sm">
                  Moderate fitness is required. You should be able to walk for
                  2-3 hours at a stretch. We recommend cardio exercises 2-3
                  weeks before the trip to prepare for high altitude.
                </p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4 md:p-5">
                <h3 className="font-semibold text-slate-900 mb-1.5 md:mb-2 text-sm md:text-base">
                  Is it safe for solo travelers?
                </h3>
                <p className="text-slate-600 text-xs md:text-sm">
                  Absolutely! Our groups are designed for solo travelers to
                  connect with like-minded adventurers. Over 60% of our
                  travelers are solo.
                </p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4 md:p-5">
                <h3 className="font-semibold text-slate-900 mb-1.5 md:mb-2 text-sm md:text-base">
                  What about altitude sickness?
                </h3>
                <p className="text-slate-600 text-xs md:text-sm">
                  Our itinerary is designed for gradual acclimatization. Day 1
                  and 2 are dedicated to rest. We carry emergency oxygen and our
                  expert is trained in altitude-related emergencies.
                </p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4 md:p-5">
                <h3 className="font-semibold text-slate-900 mb-1.5 md:mb-2 text-sm md:text-base">
                  What should I pack?
                </h3>
                <p className="text-slate-600 text-xs md:text-sm">
                  We'll send a detailed packing list upon booking. Essentials
                  include warm layers, sunscreen, sunglasses, comfortable
                  walking shoes, and a good camera!
                </p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4 md:p-5">
                <h3 className="font-semibold text-slate-900 mb-1.5 md:mb-2 text-sm md:text-base">
                  What is the best time to visit Ladakh?
                </h3>
                <p className="text-slate-600 text-xs md:text-sm">
                  The best time to visit Ladakh is from May to September when
                  the weather is pleasant and all roads are accessible. June to
                  August is peak season with the warmest temperatures.
                </p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4 md:p-5">
                <h3 className="font-semibold text-slate-900 mb-1.5 md:mb-2 text-sm md:text-base">
                  Is vegetarian food available throughout the trip?
                </h3>
                <p className="text-slate-600 text-xs md:text-sm">
                  Yes, vegetarian food is available at all locations. We cater
                  to dietary preferences and can also accommodate vegan and Jain
                  food requirements with prior notice.
                </p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4 md:p-5">
                <h3 className="font-semibold text-slate-900 mb-1.5 md:mb-2 text-sm md:text-base">
                  What is the cancellation policy?
                </h3>
                <p className="text-slate-600 text-xs md:text-sm">
                  Full refund if cancelled 30+ days before the trip. 50% refund
                  for cancellations 15-30 days before. No refund for
                  cancellations less than 15 days before departure.
                </p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4 md:p-5">
                <h3 className="font-semibold text-slate-900 mb-1.5 md:mb-2 text-sm md:text-base">
                  Do I need any special permits for Ladakh?
                </h3>
                <p className="text-slate-600 text-xs md:text-sm">
                  Yes, Inner Line Permits (ILP) are required for certain areas
                  like Pangong and Nubra Valley. Don't worry - we handle all
                  permit arrangements for you as part of the trip inclusions.
                </p>
              </div>
            </div>
          </section>
        </div>
        <div className="hidden lg:block lg:w-[340px] lg:flex-shrink-0">
          <div className="sticky top-24 space-y-4">

            <Experiencebooknow />


          </div>
        </div>
      </div>
      <div className="hidden lg:block py-10 border-t border-slate-100">
        <div className="flex items-center justify-between mb-8">
          <h3 className="text-xl font-bold text-slate-900">Traveler Reviews</h3>
          <div className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-star h-5 w-5 text-yellow-500 fill-yellow-500"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            <span className="font-semibold text-lg" />
            <span className="text-slate-400">(3 reviews)</span>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          <div className="group rounded-2xl overflow-hidden bg-white border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
            <div className="relative h-56 w-full overflow-hidden">
              <img
                alt="Priya Sharma"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0,
                  color: "transparent"
                }}
                src="/assets/images/member-1.png"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="font-semibold text-white">Priya Sharma</p>
                <p className="text-xs text-white/70">May 2024</p>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm text-slate-600 line-clamp-2">
                This trip changed my perspective on travel. Tenzing is not just
                a guide—he's a storyteller who made every monastery, every pass,
                every moment meaningful.
              </p>
            </div>
          </div>
          <div className="group rounded-2xl overflow-hidden bg-white border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
            <div className="relative h-56 w-full overflow-hidden">
              <img
                alt="Rahul Mehta"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0
                }}
                src="/assets/images/member-2.jpg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="font-semibold text-white">Rahul Mehta</p>
                <p className="text-xs text-white/70">April 2024</p>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm text-slate-600 line-clamp-2">
                The camping at Pangong Lake was surreal. Waking up to that view,
                with the best group of strangers-turned-friends—unforgettable!
              </p>
            </div>
          </div>
          <div className="group rounded-2xl overflow-hidden bg-white border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
            <div className="relative h-56 w-full overflow-hidden">
              <img
                alt="Sarah Williams"
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover transition-transform duration-500 group-hover:scale-105"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0
                }}
                src="/assets/images/member-4.jpg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="font-semibold text-white">Sarah Williams</p>
                <p className="text-xs text-white/70">March 2024</p>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm text-slate-600 line-clamp-2">
                As a solo female traveler, I felt completely safe and welcomed.
                The homestay in Turtuk was a highlight—real connection with
                local families.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="lg:hidden px-4 py-6 bg-slate-50">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-slate-900 text-base">Traveler Reviews</h3>
        <div className="flex items-center gap-1.5 bg-white px-2.5 py-1 rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-star h-3.5 w-3.5 text-yellow-500 fill-yellow-500"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
          <span className="font-semibold text-sm text-slate-900" />
          <span className="text-xs text-slate-500">(3)</span>
        </div>
      </div>
      <div className="flex gap-3 scrollbar-custom pb-2">
        <div className="flex-shrink-0 w-48 rounded-xl overflow-hidden bg-white border border-slate-100">
          <div className="relative h-40 w-full overflow-hidden">
            <img
              alt="Priya Sharma"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-1.jpg"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <p className="text-sm font-medium text-white">Priya Sharma</p>
              <p className="text-[10px] text-white/70">May 2024</p>
            </div>
          </div>
          <div className="p-3">
            <p className="text-xs text-slate-600 line-clamp-2">
              This trip changed my perspective on travel. Tenzing is not just a
              guide—he's a storyteller who made every monastery, every pass,
              every moment meaningful.
            </p>
          </div>
        </div>
        <div className="flex-shrink-0 w-48 rounded-xl overflow-hidden bg-white border border-slate-100">
          <div className="relative h-40 w-full overflow-hidden">
            <img
              alt="Rahul Mehta"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-2.jpg"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <p className="text-sm font-medium text-white">Rahul Mehta</p>
              <p className="text-[10px] text-white/70">April 2024</p>
            </div>
          </div>
          <div className="p-3">
            <p className="text-xs text-slate-600 line-clamp-2">
              The camping at Pangong Lake was surreal. Waking up to that view,
              with the best group of strangers-turned-friends—unforgettable!
            </p>
          </div>
        </div>
        <div className="flex-shrink-0 w-48 rounded-xl overflow-hidden bg-white border border-slate-100">
          <div className="relative h-40 w-full overflow-hidden">
            <img
              alt="Sarah Williams"
              loading="lazy"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/member-4.jpg"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <p className="text-sm font-medium text-white">Sarah Williams</p>
              <p className="text-[10px] text-white/70">March 2024</p>
            </div>
          </div>
          <div className="p-3">
            <p className="text-xs text-slate-600 line-clamp-2">
              As a solo female traveler, I felt completely safe and welcomed.
              The homestay in Turtuk was a highlight—real connection with local
              families.
            </p>
          </div>
        </div>
      </div>
    </div>
    
    <Experiencebooking />

  </main>
</main>




{/* Modal Popup */}
{open && (
        <div className="fixed inset-0 z-[100] flex items-end md:items-center justify-center">
  <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
  <div className="relative bg-white rounded-t-3xl md:rounded-3xl max-w-4xl w-full max-h-[90vh] md:max-h-[90vh] overflow-hidden shadow-2xl flex flex-col md:flex-row md:m-4">
    <button onClick={() => setOpen(false)}  className="absolute top-3 right-3 md:top-4 md:right-4 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/90 flex items-center justify-center hover:bg-white transition-colors z-10 shadow-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-x h-4 w-4 md:h-5 md:w-5 text-slate-600"
      >
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
    <div className="relative w-full md:w-2/5 flex-shrink-0">
      <div className="md:hidden flex justify-center items-start pt-4 pb-2 px-4 bg-slate-50">
        <div className="relative w-32 h-40 rounded-2xl overflow-hidden shadow-lg">
          <img
            alt="Tenzing Norbu"
            className="absolute inset-0 w-full h-full object-cover"
            src="/assets/images/member-1.png"
          />
        </div>
      </div>
      <div className="md:hidden text-center pb-3 bg-slate-50">
        <h2 className="text-lg font-bold text-slate-900 mb-0.5">
          Tenzing Norbu
        </h2>
        <p className="text-primary text-xs font-medium">
          High Altitude &amp; Adventure Expert
        </p>
      </div>
      <div className="hidden md:block relative h-full min-h-[600px]">
        <img
          alt="Tenzing Norbu"
          className="absolute inset-0 w-full h-full object-cover"
          src="/assets/images/member-1.png"
        />
      </div>
    </div>
    <div className="flex-1 p-4 md:p-8 overflow-y-auto max-h-[60vh] md:max-h-[90vh]">
      <div className="hidden md:block mb-6">
        <h2 className="text-3xl font-bold text-slate-900 mb-2">
          Tenzing Norbu
        </h2>
        <p className="text-primary font-medium text-lg mb-2">
          High Altitude &amp; Adventure Expert
        </p>
        <div className="flex items-center gap-2 text-slate-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-map-pin h-4 w-4"
          >
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
            <circle cx={12} cy={10} r={3} />
          </svg>
          <span>Leh, Ladakh</span>
        </div>
      </div>
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <a
          href="https://instagram.com/tenzing_norbu"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-instagram h-4 w-4"
          >
            <rect width={20} height={20} x={2} y={2} rx={5} ry={5} />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
          </svg>
          Instagram
        </a>
        <a
          href="https://facebook.com/tenzingnorbu"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-[#1877F2] text-white px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-facebook h-4 w-4"
          >
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
          </svg>
          Facebook
        </a>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base">
          About
        </h3>
        <p className="text-slate-600 leading-relaxed text-xs md:text-base">
          Former mountaineer with 15+ years of high-altitude experience.
          Summited multiple Himalayan peaks and led over 47 expeditions to
          Ladakh. Tenzing's deep connection with the land and its people
          transforms every journey into a profound experience.
        </p>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-globe h-4 w-4 text-primary"
          >
            <circle cx={12} cy={12} r={10} />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
          </svg>
          Places Explored
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Ladakh
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Spiti Valley
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Zanskar
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Nepal
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Bhutan
          </span>
          <span className="bg-emerald-50 text-emerald-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-emerald-200">
            Tibet
          </span>
        </div>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-languages h-4 w-4 text-primary"
          >
            <path d="m5 8 6 6" />
            <path d="m4 14 6-6 2-3" />
            <path d="M2 5h12" />
            <path d="M7 2h1" />
            <path d="m22 22-5-10-5 10" />
            <path d="M14 18h6" />
          </svg>
          Speaks
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
          <span className="bg-blue-50 text-blue-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-blue-200">
            Hindi
          </span>
          <span className="bg-blue-50 text-blue-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-blue-200">
            English
          </span>
          <span className="bg-blue-50 text-blue-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-blue-200">
            Ladakhi
          </span>
          <span className="bg-blue-50 text-blue-700 text-xs md:text-sm px-2.5 md:px-3 py-1 md:py-1.5 rounded-full border border-blue-200">
            Tibetan
          </span>
        </div>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-gallery-horizontal h-4 w-4 text-primary"
          >
            <path d="M2 3v18" />
            <rect width={12} height={18} x={6} y={3} rx={2} />
            <path d="M22 3v18" />
          </svg>
          Gallery
        </h3>
        <div className="grid grid-cols-4 gap-2">
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 1"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/ladakh-hero-banner.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 2"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/pangong-lake-camping.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 3"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/nubra-valley-dunes.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
          <button className="relative aspect-square rounded-lg overflow-hidden cursor-pointer group">
            <img
              alt="Gallery 4"
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              src="/assets/images/ladakh-monastery.jpg"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
          </button>
        </div>
      </div>
      <div className="mb-4 md:mb-6">
        <h3 className="font-semibold text-slate-900 mb-2 md:mb-3 text-sm md:text-base">
          Expertise
        </h3>
        <div className="flex flex-wrap gap-1.5 md:gap-2">
          <span className="bg-primary/10 text-primary text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full font-medium">
            High Altitude
          </span>
          <span className="bg-primary/10 text-primary text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full font-medium">
            Adventure Expert
          </span>
          <span className="bg-slate-100 text-slate-600 text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full">
            Local Expert
          </span>
          <span className="bg-slate-100 text-slate-600 text-xs md:text-sm px-2.5 md:px-4 py-1 md:py-1.5 rounded-full">
            Verified Host
          </span>
        </div>
      </div>
      <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 h-10 md:h-12 text-sm md:text-base font-medium">
        Book Trip with Tenzing
      </button>
    </div>
  </div>
</div>

      )}


      <Footer />
    </>
  );
};


export default ExperienceTripsDtl;


